// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Autoplay, A11y, FreeMode, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/a11y'
import 'swiper/css/navigation'
// import 'swiper/css/pagination'

const SwiperInit = () => {
  const defaultOptions = {
    modules: [Autoplay, A11y, FreeMode, Navigation]
  };

  // Initialize all swipers that have just a single swiper
  const swiperNodes = document.querySelectorAll('.swiper-single');


  [].forEach.call(swiperNodes, ( swiperInstance ) => {
    const data = swiperInstance.getAttribute('data-swiper-settings') || {};

    console.log('Found this swiper: ', swiperInstance)
    console.log('Found a swiper with this Data: ', data)

    if (data) {
      const dataOptions = JSON.parse(data);

      const mergedOptions = Object.assign({}, defaultOptions, dataOptions);
      new Swiper(swiperInstance, mergedOptions);
    }
  });


  // Initialize all gallery swipers that have a single swiper and a thumbs swiper
  // const swiperGalleryNodes = document.querySelectorAll('.swiper-gallery');

  // [].forEach.call(swiperGalleryNodes, ( swiperInstance ) => {
  //   const data = swiperInstance.getAttribute('data-swiper-settings') || {};
  //   const connectedSwiper = swiperInstance.getAttribute('data-connected-swiper') || {};
  //
  //   if (data) {
  //     const dataOptions = JSON.parse(data);
  //     let mergedThumbOptions = Object.assign({}, defaultOptions, dataOptions);
  //     const swiperThumbs = new Swiper(swiperInstance, mergedThumbOptions);
  //
  //     mergedThumbOptions = convertBooleanStrings(mergedThumbOptions);
  //
  //     const connectedSwiperNode = document.querySelector('.' + connectedSwiper);
  //     const connectedSwiperData = connectedSwiperNode.getAttribute('data-swiper-settings') || {};
  //     const connectedSwiperDataOptions = JSON.parse(connectedSwiperData);
  //     let connectedSwiperNodeOptions = Object.assign({}, defaultOptions, connectedSwiperDataOptions);
  //
  //     connectedSwiperNodeOptions.thumbs.swiper = swiperThumbs;
  //
  //     connectedSwiperNodeOptions = convertBooleanStrings(connectedSwiperNodeOptions);
  //
  //     new Swiper(connectedSwiperNode, connectedSwiperNodeOptions);
  //   }
  // });
}

const convertBooleanStrings = (obj) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === 'true') {
        obj[key] = true;
      } else if (obj[key] === 'false') {
        obj[key] = false;
      }
    }
  }
  return obj;
}

export default SwiperInit;
